export const environment = {
     baseURL: 'https://v2.api.zibills.com'
}
